// extracted by mini-css-extract-plugin
export default {"container":"Table_container__S2ZeG","scrollBar":"Table_scrollBar__VR8cM"};